// extracted by mini-css-extract-plugin
export default {"root":"view_root__l1PZm"};